<script setup>
import InREC from './InREC.vue';
import { shared } from './shared.js'
</script>

<template>
    <span v-if="deviceDetail.inrec_1">
        <table class="table table-sm text-end" v-if="check_protocol()">
            <thead>
                <tr>
                    <th></th>
                    <th class="text-center" width="150px">State</th>
                    <th class="text-center" width="75px">Mode</th>
                    <th class="text-center" width="150px">DC power</th>
                    <th class="text-center" width="75px">SoC</th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                <tr v-for="index in deviceDetail.inrecs_in_cluster" :key="index">
                    <td class="text-start">
                        <i v-if="check_updating(index)" class="bi bi-cloud-arrow-down-fill text-primary"></i>
                        <i v-else-if="check_online(index)" class="bi bi-activity text-primary"></i>
                        <i v-else class="bi bi-heartbreak-fill text-danger"></i>
                        InREC {{ index }}
                    </td>
                    <td class="fw-bold">
                        <span v-if="check_updating(index)">UPDATING</span>
                        <span v-else>{{ get_descriptive_quick(index, "system.state") }}</span>
                    </td>
                    <td>
                        <span v-if="!check_updating(index)">{{ get_data(index, "power_mode.mode") }}</span>
                    </td>
                    <td class="fw-bold">
                        <span v-if="!check_updating(index)">{{ get_data_quick(index, "avg.pdc", 0) }} W</span>
                    </td>
                    <td> 
                        <span v-if="!check_updating(index)">{{ get_data(index, "bms.soc", 0) }} %</span>
                    </td>
                </tr>
            </tbody>
            <tfoot class="table-group-divider">
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="fw-bold">{{ calculate_total_cluster_dc_power() }} W</td>
                    <td> {{ calculate_average_cluster_soc() }} %</td>
                </tr>
            </tfoot>
        </table>

        <ul class="nav nav-tabs">
            <li v-for="index in deviceDetail.inrecs_in_cluster" :key="index" class="nav-item">
                <button class="nav-link" :class="{ active: index == 1 }" data-bs-toggle="tab" :data-bs-target="'#data-inrec-' + index"
                    type="button">{{ index }}</button>
            </li>
        </ul>
        <br>
        <div class="tab-content">
            <div v-for="index in deviceDetail.inrecs_in_cluster" :key="index" class="tab-pane show" :class="{ active: index == 1 }" :id="'data-inrec-' + index">
                <InREC :deviceDetail="deviceDetail" :client="client" :inrecDevice="deviceDetail['inrec_' + (index)]" :target="'inrec_' + index" />
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: ['deviceDetail', 'client'],
    setup() { },
    data() {
        return {};
    },
    methods: {
        check_protocol() {
            return this.deviceDetail.info && this.deviceDetail.info.protocol_version != null
        },
        check_online(slave_index) {
            return shared.check_device_online(this.deviceDetail['inrec_' + (slave_index)])
        },
        check_updating(slave_index) {
            return this.deviceDetail['inrec_' + (slave_index)].status == 'updating'
        },
        get_data(slave_index, parameter, round = null) {
            return shared.get_nested_value_safely(this.deviceDetail['inrec_' + (slave_index)].data, parameter, round)
        },
        get_data_quick(slave_index, parameter, round = null) {
            return shared.get_nested_value_safely(this.deviceDetail['inrec_' + (slave_index)].data_quick, parameter, round)
        },
        get_descriptive_quick(slave_index,parameter) {
            return shared.get_descriptive_safely(this.deviceDetail['inrec_' + (slave_index)].data_quick, parameter)
        },
        calculate_total_cluster_dc_power() {
            var total_dc_power = 0;
            for (let index = 1; index <= this.deviceDetail.inrecs_in_cluster; index++) {
                var unit_dc_power = shared.get_nested_value_safely(this.deviceDetail['inrec_' + (index)].data_quick, "avg.pdc", 0)
                if (unit_dc_power != "-") {
                    total_dc_power += parseFloat(unit_dc_power)
                }
            }
            return parseFloat(total_dc_power).toFixed(0)
        },
        calculate_average_cluster_soc() {
            var summed_soc = 0;
            var nof_socs = 0
            for (let index = 1; index <= this.deviceDetail.inrecs_in_cluster; index++) {
                var unit_soc = shared.get_nested_value_safely(this.deviceDetail['inrec_' + (index)].data, "bms.soc", 0)
                if (unit_soc != "-") {
                    summed_soc += parseFloat(unit_soc)
                    nof_socs += 1
                }
            }
            if (nof_socs > 0){
                return parseFloat(summed_soc / nof_socs).toFixed(0)
            } else {
                return "-"
            }
        }
    }
};
</script>